<template>
  <vs-popup
    :title="title"
    :active.sync="visible"
    id="ConfirmDialog"
  >
    <div class="popup-content">
      <slot>

      </slot>
      <div class="popup-actions flex justify-end gap-2">
        <vs-button color="secondary" @click="handleConfirm">확인</vs-button>
        <vs-button color="#DCDFE2" text-color="black" @click="handleCancel">닫기</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props:{
    title: {
      type: String,
      default: "알림",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    handleConfirm() {
      this.resolve(true);
      this.visible = false;
    },
    handleCancel() {
      this.resolve(false);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#ConfirmDialog::v-deep {
  .vs-popup {
    width: 357px;
  }
}
</style>
